<template>
  <SettingsSectionContainer>
    <SettingsSectionDetails :title="title" :description="description" />
    <select class="SettingsSectionDropdownSelect--selector" v-model="selected">
      <option disabled value="">Please select one</option>
      <option v-for="(option, index) in options" :key="index" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </SettingsSectionContainer>
</template>

<script>
import SettingsSectionContainer from "./SettingsSectionContainer.vue";
import SettingsSectionDetails from "./SettingsSectionDetails.vue";
export default {
  name: "Select",
  components: {
    SettingsSectionContainer,
    SettingsSectionDetails,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    currentSelection: {
      type: [String, Number],
    },
    options: Array,
  },
  methods: {
    select(newValue) {
      this.$emit("selected", newValue);
    },
  },
  computed: {
    selected: {
      get() {
        return this.currentSelection;
      },
      set(newValue) {
        this.select(newValue);
      },
    },
  },
};
</script>

<style>
.SettingsSectionDropdownSelect--selector {
  background-color: #fff;
  color: #333;
  border-radius: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
  outline: none;
  height: 35px;
  box-sizing: border-box;
  border-color: transparent;
  font-size: 15px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  font-family: "Nunito";
  padding-left: 10px;
  padding-right: 10px;
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  width: 120px;
  text-align: center;
  margin-left: 15px;
}
.SettingsSectionDropdownSelect--selector:hover {
  background-color: #e8e8e8;
}
</style>
